import { axiosInstance } from "api/axios-config/axios-config";
import { GetExportExcelPapersGoodsReceipt } from "api/models/request/paper-inventory/paper-inventory";
import {
  IAddPaperGoodsReceipt,
  IUpdatePaperGoodsReceipt,
} from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt";
import { IPaperGoodsReceiptItemProperties } from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt-item";
import { BaseBussiness } from "../base";

class PaperGoodsReceiptBusiness extends BaseBussiness<
  IPaperGoodsReceiptItemProperties,
  IAddPaperGoodsReceipt,
  IUpdatePaperGoodsReceipt,
  IPaperGoodsReceiptItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public async getReceiptedRollNumbersByPaperMaterialId(
    materialId: string,
  ): Promise<IPaperGoodsReceiptItemProperties[]> {
    try {
      const url = `${this.url}/receipted-roll-number-by-material/${materialId}`;
      const res =
        await axiosInstance.get<IPaperGoodsReceiptItemProperties[]>(url);
      return res.data;
    } catch (error) {
      console.error("Fail get lists", error);
      return Promise.reject(error);
    }
  }

  public exportExcel = async (req: GetExportExcelPapersGoodsReceipt) => {
    try {
      var res = await axiosInstance.get(this.url + "/export-excel", {
        params: req,
        responseType: "blob",
      });

      return res.data as Blob;
    } catch (error) {
      console.error("Fail exportExcel", error);
      return Promise.reject(error);
    }
  };
}

export const paperGoodsReceiptBusiness = new PaperGoodsReceiptBusiness(
  "/api/app/paper-goods-receipt",
);
